/* eslint-disable complexity */ import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { LayoutElementBasedCarousel } from "@faire/retailer-visitor-shared/components/LayoutElementRenderer/LayoutElementBasedCarousel";
import { TitleStyles } from "@faire/retailer-visitor-shared/components/LayoutElementRenderer/styles/TitleStyles";
import { Column, Flex, HorizontalLine } from "@faire/web--source/slate/Layout";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography, TypographyStyles } from "@faire/web--source/slate/Typography";
import { useDoActionWhenVisible } from "@faire/web--source/ui/hooks/useDoActionWhenVisible";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { trackCategoriesLayoutElementCtaClick } from "@faire/web-api--source/events/categories/click/layoutElementCta";
import { trackCategoriesLoggedOutCategoryBottomCarouselClick } from "@faire/web-api--source/events/categories/click/loggedOutCategoryBottomCarousel";
import { trackCategoriesLoggedOutCategoryTopCarouselClick } from "@faire/web-api--source/events/categories/click/loggedOutCategoryTopCarousel";
import { trackCategoriesLayoutElementView } from "@faire/web-api--source/events/categories/view/layoutElement";
import { ILayoutElement } from "@faire/web-api--source/indigofair/data/ILayoutElement";
import React, { useCallback } from "react";
import styled from "styled-components";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { CommunityCategoryBannerBase as CommunityCategoryBanner } from "@faire/retailer/components/LayoutElementRenderer/__internal__/Banner/ByType/CommunityCategoryBanner";
import { LayoutElementBasedBanner } from "@faire/retailer/components/LayoutElementRenderer/LayoutElementBasedBanner";
import { ShowroomTitleBanner } from "@faire/retailer/features/Showroom/ApparelCategory/ShowroomTitleBanner";
import { LoggedOutCategoryPageBreadcrumb } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/components/LoggedOutCategoryPageAboveFold/LoggedOutCategoryPageBreadcrumb";
import { LoggedOutCategoryPageHeroBanner } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/components/LoggedOutCategoryPageLayoutElements/__internal__/LoggedOutCategoryPageHeroBanner";
import { useLoggedOutCategoryPageCurrentCategory } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/Context/useLoggedOutCategoryPageCurrentCategory";
export var LoggedOutCategoryPageLayoutElementRenderer = function(param) {
    var layoutElement = param.layoutElement, requestId = param.requestId, shouldDisplayShowroomBanner = param.shouldDisplayShowroomBanner, placement = param.placement;
    var category = useLoggedOutCategoryPageCurrentCategory();
    var _useViewport = useViewport(), isMobile = _useViewport.isMobile, isTabletAndAbove = _useViewport.isTabletAndAbove, isDesktop = _useViewport.isDesktop;
    var avatarGridOnItemClick = useCallback(function(categoryLink) {
        trackCategoriesLoggedOutCategoryTopCarouselClick(categoryLink);
    }, []);
    var ref = useDoActionWhenVisible(function() {
        var _layoutElement_on_click_event_name;
        return trackCategoriesLayoutElementView((_layoutElement_on_click_event_name = layoutElement.on_click_event_name) !== null && _layoutElement_on_click_event_name !== void 0 ? _layoutElement_on_click_event_name : "", requestId !== null && requestId !== void 0 ? requestId : "", "");
    });
    if (layoutElement.placement !== placement) {
        return null;
    }
    switch(layoutElement.type){
        case ILayoutElement.Type.AVATAR_CAROUSEL_WITH_GRID:
            {
                var _layoutElement_layout_element_data;
                var _layoutElement_layout_element_data_length;
                var tilesLength = (_layoutElement_layout_element_data_length = (_layoutElement_layout_element_data = layoutElement.layout_element_data) === null || _layoutElement_layout_element_data === void 0 ? void 0 : _layoutElement_layout_element_data.length) !== null && _layoutElement_layout_element_data_length !== void 0 ? _layoutElement_layout_element_data_length : 0;
                var itemsPerSlide = {
                    mobileAndAbove: Math.min(3, tilesLength),
                    tabletAndAbove: Math.min(3, tilesLength),
                    desktopAndAbove: Math.min(3, tilesLength),
                    xLargeAndAbove: Math.min(5, tilesLength)
                };
                return /*#__PURE__*/ _jsxs(Wrapper, {
                    children: [
                        /*#__PURE__*/ _jsxs(HeaderWrapper, {
                            children: [
                                /*#__PURE__*/ _jsx(TitleH1, {
                                    children: layoutElement.main_text
                                }),
                                /*#__PURE__*/ _jsx(TitleH2, {
                                    children: layoutElement.description_text
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs(StyledCarouselWrapper, {
                            "data-test-id": "embla-carousel-wrapper",
                            $itemPerSlide: itemsPerSlide,
                            $type: layoutElement.type,
                            children: [
                                /*#__PURE__*/ _jsx(LayoutElementBasedCarousel, {
                                    layoutElement: layoutElement,
                                    requestId: requestId !== null && requestId !== void 0 ? requestId : "",
                                    itemsPerSlide: itemsPerSlide,
                                    onItemClick: avatarGridOnItemClick,
                                    hideTitle: true
                                }),
                                isMobile && layoutElement.layout_element_data.length > 0 ? /*#__PURE__*/ _jsxs(_Fragment, {
                                    children: [
                                        /*#__PURE__*/ _jsx(Spacer, {
                                            size: "3x"
                                        }),
                                        /*#__PURE__*/ _jsx(StyledHorizontalLine, {}),
                                        /*#__PURE__*/ _jsx(Spacer, {
                                            size: "4x"
                                        })
                                    ]
                                }) : null
                            ]
                        }),
                        isDesktop ? /*#__PURE__*/ _jsx(Spacer, {
                            size: "3x"
                        }) : null
                    ]
                });
            }
        case ILayoutElement.Type.AVATAR_CAROUSEL:
            {
                var _layoutElement_layout_element_data1;
                var _layoutElement_layout_element_data_length1;
                var tilesLength1 = (_layoutElement_layout_element_data_length1 = (_layoutElement_layout_element_data1 = layoutElement.layout_element_data) === null || _layoutElement_layout_element_data1 === void 0 ? void 0 : _layoutElement_layout_element_data1.length) !== null && _layoutElement_layout_element_data_length1 !== void 0 ? _layoutElement_layout_element_data_length1 : 0;
                var itemsPerSlide1 = {
                    mobileAndAbove: Math.min(3, tilesLength1),
                    tabletAndAbove: Math.min(6, tilesLength1),
                    desktopAndAbove: Math.min(8, tilesLength1)
                };
                return /*#__PURE__*/ _jsxs(StyledCarouselWrapper, {
                    "data-test-id": "embla-carousel-wrapper",
                    $itemPerSlide: itemsPerSlide1,
                    $type: layoutElement.type,
                    style: {
                        alignSelf: isTabletAndAbove ? "center" : "unset"
                    },
                    children: [
                        /*#__PURE__*/ _jsx(LayoutElementBasedCarousel, {
                            layoutElement: layoutElement,
                            requestId: requestId !== null && requestId !== void 0 ? requestId : "",
                            itemsPerSlide: itemsPerSlide1,
                            onItemClick: trackCategoriesLoggedOutCategoryBottomCarouselClick
                        }),
                        /*#__PURE__*/ _jsx(Spacer, {
                            height: "6x"
                        })
                    ]
                });
            }
        case ILayoutElement.Type.MID_PRICE_POINT_PLUS_PAGE_TITLE:
            if (shouldDisplayShowroomBanner) {
                return /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(ShowroomTitleBanner, {
                            layoutElement: layoutElement,
                            category: category,
                            isLoggedOutPage: true
                        }),
                        /*#__PURE__*/ _jsx(Spacer, {
                            height: {
                                mobileAndAbove: "3x",
                                tabletAndAbove: "4x"
                            }
                        })
                    ]
                });
            }
            return null;
        case ILayoutElement.Type.COMMUNITY_CATEGORY_BANNER:
            return /*#__PURE__*/ _jsx("div", {
                ref: ref,
                children: /*#__PURE__*/ _jsx(CommunityCategoryBanner, {
                    layoutElement: layoutElement,
                    onCTAClick: function(eventName, requestId) {
                        trackCategoriesLayoutElementCtaClick(eventName, requestId);
                    },
                    requestId: requestId
                })
            });
        case ILayoutElement.Type.SHOWROOM_VALUES_TITLE_BANNER:
        case ILayoutElement.Type.FULL_WIDTH_IMAGE_BANNER:
            return /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(LayoutElementBasedBanner, {
                        layoutElement: layoutElement,
                        requestId: requestId !== null && requestId !== void 0 ? requestId : "",
                        onVisible: function() {
                            var _layoutElement_on_click_event_name;
                            return trackCategoriesLayoutElementView((_layoutElement_on_click_event_name = layoutElement.on_click_event_name) !== null && _layoutElement_on_click_event_name !== void 0 ? _layoutElement_on_click_event_name : "", requestId !== null && requestId !== void 0 ? requestId : "", "");
                        }
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {
                        height: {
                            mobileAndAbove: "3x",
                            tabletAndAbove: "4x"
                        }
                    })
                ]
            });
        case ILayoutElement.Type.MARKETING_BANNER:
            return /*#__PURE__*/ _jsx(LoggedOutCategoryPageHeroBanner, {
                layoutElement: layoutElement
            });
        case ILayoutElement.Type.TALL_CATEGORY_TILE:
            return /*#__PURE__*/ _jsx(StyledSubcategoryCarousel, {
                children: /*#__PURE__*/ _jsx(LayoutElementBasedCarousel, {
                    arrowOffsetX: 0,
                    layoutElement: layoutElement,
                    requestId: requestId !== null && requestId !== void 0 ? requestId : "",
                    onItemClick: trackCategoriesLoggedOutCategoryBottomCarouselClick,
                    showNavigationArrows: {
                        mobileAndAbove: false,
                        desktopAndAbove: true
                    }
                })
            });
        case ILayoutElement.Type.SIMPLE_TEXT_BANNER:
            // "all products" subheader above filter row
            if (!layoutElement.description_text) {
                return /*#__PURE__*/ _jsx(Typography, {
                    variant: {
                        mobileAndAbove: "pageHeaderSerifRegular",
                        xLargeAndAbove: "displaySSerifRegular"
                    },
                    children: layoutElement.main_text
                });
            }
            // header and subheader
            return /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        as: "h1",
                        variant: {
                            mobileAndAbove: "displaySSerifRegular",
                            xLargeAndAbove: "displayMSerifRegular"
                        },
                        children: layoutElement.main_text
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {
                        height: "1x"
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: {
                            mobileAndAbove: "paragraphSansRegular",
                            xLargeAndAbove: "subheadingSansRegular"
                        },
                        children: layoutElement.description_text
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {
                        height: {
                            mobileAndAbove: "3x",
                            tabletAndAbove: "4x"
                        }
                    })
                ]
            });
        case ILayoutElement.Type.BREADCRUMB:
            return /*#__PURE__*/ _jsx(StyledBreadcrumbWithLOCPRedesign, {});
        default:
            return null;
    }
};
var StyledCarouselWrapper = styled.div.withConfig({
    componentId: "sc-dad5c248-0"
})([
    "min-width:0;--item-per-slide-xlarge:",
    ";--item-per-slide-desktop:",
    ";--item-per-slide-tablet:",
    ";--item-per-slide-mobile:",
    ";",
    "{align-self:center;align-items:center;width:max-content;}",
    "{",
    "{padding-left:20px;align-self:flex-start;}}",
    "{margin-right:40px;width:calc( 88px * var(--item-per-slide-tablet) + 16px * (var(--item-per-slide-tablet) - 1) );}",
    "{width:calc( 88px * var(--item-per-slide-desktop) + 16px * (var(--item-per-slide-desktop) - 1) );}",
    "{width:calc( 88px * var(--item-per-slide-xlarge) + 16px * (var(--item-per-slide-xlarge) - 1) );}"
], function(props) {
    var _props_$itemPerSlide_xLargeAndAbove;
    return (_props_$itemPerSlide_xLargeAndAbove = props.$itemPerSlide.xLargeAndAbove) !== null && _props_$itemPerSlide_xLargeAndAbove !== void 0 ? _props_$itemPerSlide_xLargeAndAbove : props.$itemPerSlide.desktopAndAbove;
}, function(props) {
    return props.$itemPerSlide.desktopAndAbove;
}, function(props) {
    return props.$itemPerSlide.tabletAndAbove;
}, function(props) {
    return props.$itemPerSlide.mobileAndAbove;
}, TitleStyles.Container, responsiveMediaQueries.mobile, TitleStyles.Container, responsiveMediaQueries.tablet, responsiveMediaQueries.desktopAndAbove, responsiveMediaQueries.xLargeAndAbove);
var StyledHorizontalLine = styled(HorizontalLine).withConfig({
    componentId: "sc-dad5c248-1"
})([
    "width:100vw !important;margin-left:calc(-50vw + 50%) !important;"
]);
var Wrapper = styled(Flex).attrs({
    direction: {
        tabletAndAbove: "row",
        mobileAndAbove: "column-reverse"
    }
}).withConfig({
    componentId: "sc-dad5c248-2"
})([
    "width:100%;",
    "{padding:0 16px;}"
], responsiveMediaQueries.mobile);
// eslint-disable-next-line @faire/prefer-slate-attrs
var HeaderWrapper = styled(Column).withConfig({
    componentId: "sc-dad5c248-3"
})([
    "",
    "{flex:1 0 50%;padding-right:80px;}",
    "{flex:1 0 53%;padding-right:40px;}",
    "{align-items:center;justify-content:center;text-align:center;}"
], responsiveMediaQueries.desktopAndAbove, responsiveMediaQueries.tablet, responsiveMediaQueries.mobile);
// For SEO purpose, we have to make this h1 tag, please don't change unless
// consulted with the SEO team
var TitleH1 = styled.h1.withConfig({
    componentId: "sc-dad5c248-4"
})([
    "",
    " margin-bottom:8px;",
    "{text-align:center;}"
], TypographyStyles({
    variant: "pageHeaderSerifRegular"
}), responsiveMediaQueries.mobile);
// For SEO purpose, we have to make this h2 tag, please don't change unless
// consulted with the SEO team
var TitleH2 = styled.h2.withConfig({
    componentId: "sc-dad5c248-5"
})([
    "",
    " max-width:100%;",
    "{max-width:400px;}"
], TypographyStyles({}), responsiveMediaQueries.mobile);
var StyledSubcategoryCarousel = styled.div.withConfig({
    componentId: "sc-dad5c248-6"
})([
    "padding-bottom:",
    ";",
    "{",
    "{padding-left:",
    ";}margin:",
    ";padding-bottom:",
    ";}"
], getSpacing("4x"), responsiveMediaQueries.mobile, TitleStyles.Container, getSpacing("2x"), getSpacing(0, "-2x"), getSpacing("3x"));
var StyledBreadcrumbWithLOCPRedesign = styled(LoggedOutCategoryPageBreadcrumb).withConfig({
    componentId: "sc-dad5c248-7"
})([
    "max-width:unset;padding:",
    ";",
    "{padding:",
    ";}"
], getSpacing("4x", 0, "1x", 0), responsiveMediaQueries.tabletAndBelow, getSpacing("3x", 0, "1x", 0));
